import { formatMeetingId } from '../../shared/protocol';
import { joinUrl } from './api';
import { formatDateTime, formatDuration } from './format';

export interface InviteSource {
  id: string;
  title: string;
  passcode: string | null;
  startTime: string | null;
  durationMinutes: number;
}

export function inviteText(m: InviteSource, hostName?: string): string {
  const lines = [
    `${hostName ? `${hostName} te invita` : 'Te invitan'} a una reunión de Nexo Meet.`,
    '',
    `Tema: ${m.title}`,
  ];
  if (m.startTime) lines.push(`Hora: ${formatDateTime(m.startTime)} (${formatDuration(m.durationMinutes)})`);
  lines.push('', 'Entrar a la reunión:', joinUrl(m.id, m.passcode), '', `ID de reunión: ${formatMeetingId(m.id)}`);
  if (m.passcode) lines.push(`Código de acceso: ${m.passcode}`);
  return lines.join('\n');
}

const icsEscape = (s: string) => s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/[,;]/g, (c) => `\\${c}`);
const icsDate = (d: Date) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

/** RFC 5545 calendar file so scheduled meetings can be added to any calendar app. */
export function buildIcs(m: InviteSource & { startTime: string }): string {
  const start = new Date(m.startTime);
  const end = new Date(start.getTime() + m.durationMinutes * 60_000);
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Nexo Meet//ES',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:${m.id}@nexo-meet`,
    `DTSTAMP:${icsDate(new Date())}`,
    `DTSTART:${icsDate(start)}`,
    `DTEND:${icsDate(end)}`,
    `SUMMARY:${icsEscape(m.title)}`,
    `DESCRIPTION:${icsEscape(inviteText(m))}`,
    `URL:${joinUrl(m.id, m.passcode)}`,
    'END:VEVENT',
    'END:VCALENDAR',
    '',
  ].join('\r\n');
}

export function downloadIcs(m: InviteSource & { startTime: string }): void {
  const blob = new Blob([buildIcs(m)], { type: 'text/calendar;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `reunion-${m.id}.ics`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
